<template>
  <div class="container">
    <div class="content">
      <h1 class="title" @click="goback">
        <span class="icon-back"></span>{{ title }}
      </h1>
      <slot></slot>
    </div>
    <div class="contact">
      <author-contact-us></author-contact-us>
    </div>
  </div>
</template>

<script>
import AuthorContactUs from '../AuthorContactUs'
export default {
  name: 'CourseContainer',
  components: { AuthorContactUs },
  props: ['title'],
  methods: {
    goback() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}

.content {
  flex: auto;
  margin-right: 40px;
  padding: 0 30px;
  background-color: #ffffff;
  border: solid 1px #ebebeb;
  border-radius: 5px;
}

.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  height: 50px;
  font-weight: bold;
  line-height: 20px;
  letter-spacing: 1px;
  color: #262626;
  border-bottom: solid 1px #ebebeb;
  cursor: pointer;
}

.icon-back {
  position: relative;
  display: inline-block;
  width: 18px;
  height: 2px;
  margin-right: 10px;
  background-color: #a3a29e;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -10px;
    width: 8px;
    height: 8px;
    border-left: 2px solid #a3a29e;
    border-bottom: 2px solid #a3a29e;
    transform: rotate(45deg);
    transform-origin: 0 100%;
  }
}

.contact {
  background-color: #ffffff;
  border-radius: 5px;
}
</style>
